module.exports = __webpack_public_path__ + "static/media/pinterest.81a9457f.svg";